module.exports = __webpack_public_path__ + "img/c2.353b56ca.png";